<template>
    <div class="upsert-no-contract-payout">
        <transition name="dialogfade">
            <k-dialog v-if="showDialog" class="default__dialog upsert-no-contract-payout-dialog">
                <div class="icon__container">
                    <i class="fa-solid fa-money-check-dollar-pen"></i>
                </div>
                <div class="header__container">
                    <svg viewBox="0 0 300 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" class="icon__top-bar" clip-rule="evenodd" d="M10 0C4.47715 0 0 4.47715 0 10V50H300V10C300 4.47715 295.523 0 290 0H184.388C184.388 9.01736 180.732 17.6654 174.226 24.0416C167.72 30.4179 158.895 34 149.694 34C140.492 34 131.668 30.4179 125.161 24.0416C118.655 17.6654 115 9.01737 115 5.13386e-06L149.694 0H10Z" fill="#D4B139"></path></svg>
                </div>
                <div class="create-document__header">
                    <h1 class="dialog--title">{{ editMode ? 'Edit Record' : 'Create Record' }}</h1>
                </div>
                <div class="upsert-item__container">
                    <section class="upsert-item__section">
                        <div class="input__row pair">
                            <label class="input__label">
                                Company Name
                                <k-input v-model="payout.companyName" />
                            </label>
                            <label class="input__label">
                                Payout Amount
                                <k-numeric-input v-model="payout.payoutAmount" :format="'c2'" :min="0"></k-numeric-input>
                            </label>
                        </div>
                        <div class="input__row pair">
                            <label class="input__label">
                                Payout Date
                                <k-datepicker v-model="payout.payoutDate"></k-datepicker>
                            </label>
                            <label class="input__label">
                                Deposit Date
                                <k-datepicker v-model="payout.depositDate"></k-datepicker>
                            </label>
                        </div>
                    </section>
                    <k-action-bar>
                        <k-button class="item-save__btn" @click="onSaveClicked">Save</k-button>
                        <k-button class="item-cancel__btn" @click="onCancelClicked">Cancel</k-button>
                    </k-action-bar>
                </div>
            </k-dialog>
        </transition>

        <div class="loader-container" v-if="isLoading">
            <k-loader :size="'large'" :type="'infinite-spinner'"></k-loader>
        </div>

        <transition name="dialogfade">
            <k-dialog v-if="showErrorDialog" :title="errorTitle" class="error__dialog" @close="toggleErrorDialog">
                <p class="error-dialog__msg">{{ errorMsg }}</p>
            </k-dialog>
        </transition>

        <k-notification-group class="default-notification-container">
                <k-fade :appear="successNotification">
                    <k-notification v-if="successNotification"
                                    :type="{ style: 'success', icon: true }"
                                    :closable="true"
                                    @close="onCloseNotification('successNotification')">
                        <span>{{ notificationMsg }}</span>
                    </k-notification>
                </k-fade>
        </k-notification-group>
    </div>
</template>

<script>
    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
    import { Button } from "@progress/kendo-vue-buttons";
    import { Loader } from "@progress/kendo-vue-indicators";
    import { Notification, NotificationGroup } from "@progress/kendo-vue-notification";
    import { Fade } from "@progress/kendo-vue-animation";
    import { DatePicker } from '@progress/kendo-vue-dateinputs';
    import { NumericTextBox, Input } from "@progress/kendo-vue-inputs";

    import cloneDeep from 'lodash.clonedeep';

    import auth from '../authConfig';
    import apiService from '../api/api.service.js';

    export default {
        name: 'upsertNoContractPayoutDialog',
        props: ['addMode', 'editedPayout', 'editMode', 'playerId', 'showDialog'],
        emits: ['dialogclosed', 'payoutsupdated'],
        data () {
            return {
                errorMsg: '',
                errorTitle: '',
                isLoading: false,
                notificationMsg: '',
                payoutModel: {
                    payoutAmount: null,
                    payoutDate: null,
                    companyName: null,
                    depositDate: null,
                    playerId: null
                },
                payout: {},
                showErrorDialog: false,
                successNotification: false
            }
        },
        watch: {
            showDialog(val) {
                if (val) {
                    this.assignPayout();
                } else {
                    this.resetDefaults();
                }
            }
        },
        methods: {
            assignPayout() {
                if (this.editMode) {
                    return this.payout = cloneDeep(this.editedPayout);
                }

                this.payout = cloneDeep(this.payoutModel);
            },
            onCancelClicked() {
                this.$emit('dialogclosed');
            }, 
            onCloseNotification(flag) {
                this[flag] = false;
            },
            onRequestError(errorTitle, errorMsg) {
                this.isLoading = false;

                this.errorTitle = errorTitle;

                if (errorMsg) {
                    this.errorMsg = errorMsg;
                } else {
                    this.errorMsg = 'Please try again';
                }

                this.showErrorDialog = true;
            },
            onSaveClicked() {
                this.payout.playerId = this.playerId;
                let request = cloneDeep(this.payout);

                this.upsertPayout(request);
            },
            resetDefaults() {
                this.payout = {};
            },
            showNotification(notificationMsg) {
                this.notificationMsg = notificationMsg;

                this.successNotification = true;

                setTimeout(() => {
                    this.successNotification = false;
                }, 4000);
            },
            toggleErrorDialog() {
                this.showErrorDialog = !this.showErrorDialog;

                if(!this.showErrorDialog) {
                    this.errorTitle = '';
                    this.errorMsg = '';
                }
            },
            async upsertPayout(request) {
                let self = this;

                this.isLoading = true;
                this.$emit('dialogclosed');

                let tokenResponse = await auth.acquireTokenResponse();

                return apiService.UpsertNoContractPayout(tokenResponse.accessToken, request)
                    .then((res) => {
                        self.isLoading = false;
                        self.showNotification('Payout updated successfully');

                        self.$emit('payoutsupdated', res.data.data);
                    }).catch(error => {
                        console.log(error);
                        self.onRequestError('An Error Occurred', error?.response?.data?.message);
                    });
            }
        },
        components: {
            'k-dialog': Dialog,
            'k-action-bar': DialogActionsBar,
            'k-button': Button,
            'k-loader': Loader,
            'k-notification': Notification,
            'k-notification-group': NotificationGroup,
            'k-fade': Fade,
            'k-datepicker': DatePicker,
            'k-input': Input,
            'k-numeric-input': NumericTextBox
        }
    }
</script>

<style>
    @import '/src/assets/css/defaultUpsertStyles.css';
    @import '/src/assets/css/upsertNoContractPayoutDialog.css';
</style>